import { type EmailTemplate, type Opportunity } from "@repo/api";
import { useSettings } from "@repo/ui";
import { useMemo } from "react";

export const useTemplatesByHfb = (
  opportunity: Opportunity
): EmailTemplate[] => {
  const { communication_templates } = useSettings();

  return useMemo(() => {
    const templates = communication_templates?.email_templates ?? [];

    const hfbGroupings = communication_templates?.hfb_grouping ?? [];

    const opportunityHfbs = opportunity.hfb ?? [];

    if (opportunityHfbs.length === 0) {
      return [];
    }

    const allowedTemplateIds = new Set(
      hfbGroupings
        .filter((group) => opportunityHfbs.includes(group.hfbs_list))
        .flatMap((group) => group.templates.map((t) => t.template_id_key))
    );

    return templates.filter((template) =>
      allowedTemplateIds.has(template.template_id_key)
    );
  }, [
    communication_templates?.email_templates,
    communication_templates?.hfb_grouping,
    opportunity.hfb,
  ]);
};
